import { IconProps } from "./iconTypes";

export default function MicFilledIcon(props: IconProps) {
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' {...props}>
      <path
        d='M5.83158 5.83317C5.83158 3.53198 7.69706 1.6665 9.99825 1.6665C12.2994 1.6665 14.1649 3.53198 14.1649 5.83317V9.58317C14.1649 11.8844 12.2994 13.7498 9.99825 13.7498C7.69706 13.7498 5.83158 11.8844 5.83158 9.58317V5.83317Z'
        fill='currentColor'
      />
      <path
        d='M16.3009 12.3334L16.5511 11.7607L15.4057 11.2602L15.1554 11.8329C14.2869 13.8209 12.3038 15.2082 9.99821 15.2082C7.69257 15.2082 5.70956 13.8209 4.84099 11.8329L4.59075 11.2602L3.44531 11.7607L3.69554 12.3334C4.67665 14.5789 6.82374 16.2004 9.37321 16.4301V18.3332H10.6232V16.4301C13.1727 16.2004 15.3198 14.5789 16.3009 12.3334Z'
        fill='currentColor'
      />
    </svg>
  );
}
